import { PageHero } from "../components/PageHero";
import { Stats } from "../components/Intro";
import { WhyBlocks } from "../components/WhyBlocks";
import { CessnaBand, FlightLoggerSection, ExamCentreSection, AltonSection, HangarSection } from "../components/Highlights";
import { PartnerMarquee } from "../components/PartnerMarquee";
import { CTABand } from "../components/CTABand";
import { Reveal, Overline } from "../components/Reveal";
import { WHY_BLOCKS, STORY } from "../data";

export default function About({ onApply }) {
  return (
    <>
      <PageHero media="/videos/about.mp4" poster="/img/tail.webp" overline="About Us" title="More than a flight school —" highlight="a standard." subtitle="Experience, uncompromising standards and a modern, structured training system — the reasons serious pilots choose Eagle 1." />
      <section className="py-24 lg:py-32 bg-white" data-testid="about-story">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <Reveal><Overline>Our Story</Overline></Reveal>
            <Reveal delay={0.1}><h2 className="mt-5 font-display font-light text-4xl md:text-5xl tracking-tight text-[var(--primary)] leading-[1.05]">From two leased aircraft to a continental benchmark.</h2></Reveal>
          </div>
          <div className="lg:col-span-7">
            <Reveal delay={0.15}><p className="text-[var(--muted)] text-lg leading-relaxed">{STORY}</p></Reveal>
          </div>
        </div>
      </section>
      <HangarSection />
      <CessnaBand />
      <PartnerMarquee />
      <Stats />
      <FlightLoggerSection />
      <ExamCentreSection />
      <AltonSection />
      <WhyBlocks overline="Why South Africa?" title="One of the world's best" highlight="value destinations." blocks={WHY_BLOCKS.sa} />
      <WhyBlocks overline="Why Rand Airport?" title="A pilot's" highlight="one-stop shop." blocks={WHY_BLOCKS.rand} alt />
      <WhyBlocks overline="Why Eagle 1?" title="Experience, structure and" highlight="relentless standards." blocks={WHY_BLOCKS.eagle} />
      <CTABand onApply={onApply} />
    </>
  );
}
